import React from 'react';
import { createPortal } from 'react-dom';

function ClockIcon() {
  return (
    <svg width="26" height="26" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 2.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15zM4 10a6 6 0 1112 0 6 6 0 01-12 0zm6.75-3.25a.75.75 0 00-1.5 0V10c0 .2.08.39.22.53l2.5 2.5a.75.75 0 101.06-1.06L10.75 9.7V6.75z"
        fill="currentColor"
      />
    </svg>
  );
}

const L = {
  fr: {
    title: 'Votre essai gratuit est terminé',
    body: 'Choisissez un forfait pour continuer à utiliser KIO sans interruption. Sinon, vous serez déconnecté(e).',
    upgrade: 'Choisir un forfait',
    logout: 'Se déconnecter',
  },
  en: {
    title: 'Your free trial has ended',
    body: 'Choose a plan to keep using KIO without interruption. Otherwise you will be logged out.',
    upgrade: 'Choose a plan',
    logout: 'Log out',
  },
  ar: {
    title: 'انتهت فترتك التجريبية المجانية',
    body: 'اختر باقة لمواصلة استخدام KIO دون انقطاع. وإلا سيتم تسجيل خروجك.',
    upgrade: 'اختر باقة',
    logout: 'تسجيل الخروج',
  },
};

/** Shown once the trial countdown hits zero — gives one last chance to upgrade
 *  before ending the session, instead of logging the user out silently. */
export default function TrialExpiredModal({ lang = 'fr', onUpgrade, onLogout }) {
  const l = L[lang] || L.fr;
  const isRtl = lang === 'ar';

  React.useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onLogout(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onLogout]);

  return createPortal(
    <div
      dir={isRtl ? 'rtl' : 'ltr'}
      role="dialog"
      aria-modal="true"
      aria-labelledby="kio-trial-expired-title"
      onClick={onLogout}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 2147483000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(0,0,0,0.55)',
        padding: 16,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: 440,
          background: '#fff',
          borderRadius: 16,
          boxShadow: '0 24px 64px rgba(0,0,0,0.28)',
          overflow: 'hidden',
        }}
      >
        <div style={{ padding: '22px 24px 8px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 14 }}>
            <div style={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              background: '#fef2f2',
              color: '#dc2626',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}>
              <ClockIcon />
            </div>
          </div>
          <h2
            id="kio-trial-expired-title"
            style={{
              margin: '0 0 10px',
              fontSize: 18,
              fontWeight: 700,
              color: '#1a1a1a',
              textAlign: 'center',
              lineHeight: 1.35,
            }}
          >
            {l.title}
          </h2>
          <p style={{
            margin: 0,
            fontSize: 14,
            lineHeight: 1.5,
            color: '#4b5563',
            textAlign: 'center',
          }}>
            {l.body}
          </p>
        </div>

        <div style={{
          display: 'flex',
          gap: 10,
          justifyContent: 'flex-end',
          padding: '16px 24px 20px',
        }}>
          <button
            type="button"
            onClick={onLogout}
            style={{
              padding: '9px 16px',
              borderRadius: 8,
              border: '1px solid #d1d5db',
              background: '#fff',
              color: '#374151',
              fontSize: 13,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            {l.logout}
          </button>
          <button
            type="button"
            onClick={onUpgrade}
            style={{
              padding: '9px 16px',
              borderRadius: 8,
              border: 'none',
              background: '#18181b',
              color: '#fff',
              fontSize: 13,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            {l.upgrade}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
